var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.47301 0 0 4.47254 0 10C0 15.527 4.47254 20 10 20C15.527 20 20 15.5275 20 10C20 4.47305 15.5275 0 10 0ZM10 18.6667C5.22121 18.6667 1.33332 14.7788 1.33332 10C1.33332 5.22117 5.22121 1.33332 10 1.33332C14.7788 1.33332 18.6667 5.22121 18.6667 10C18.6667 14.7788 14.7788 18.6667 10 18.6667Z",
    fill: "#ABAFB9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0615 9.80023H9.88219V6.08709C9.88219 5.71893 9.58371 5.42041 9.21551 5.42041C8.84731 5.42041 8.54883 5.71889 8.54883 6.08709V10.4669C8.54883 10.835 8.84731 11.1335 9.21551 11.1335H12.0615C12.4296 11.1335 12.7281 10.8351 12.7281 10.4669C12.7281 10.0987 12.4297 9.80023 12.0615 9.80023Z",
    fill: "#ABAFB9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.879e34367e3a3ea19b654a9978ef5573.svg";
export { ForwardRef as ReactComponent };